<template>
    <div>
        <div class="SearchNav">
            <div class="SearchNav-columns">
                <div class="col-logo">
                    <img class="SearchNav__BrandImage" :src="require('../../assets/images/jhf_logo.svg')" @click="toHome" />
                </div>
                <div class="col-search">
                    <div class="col-search-container">
                        <SearchInput :limitNum="limitNum"/>
                        <SearchAdvancedNav />
                    </div>
                </div>
                <div class="col-nav">
                    <ul class="SearchNav__Navigation">
                        <li class="SearchNav__navitem">
                            <el-button class="lang-btn Header__Navigation Header__Navitem" v-if="$store.state.general.language === 'english'" @click.native="language('japanese')">
                                日本語
                            </el-button>
                            <el-button class="lang-btn Header__Navigation Header__Navitem" v-if="$store.state.general.language === 'japanese'" @click.native="language('english')">
                                English
                            </el-button>
                        </li>
                        <li class="SearchNav__navitem">
                            <router-link to="/help" class="">{{'Help' | language}}</router-link>
                        </li>
                        <li class="SearchNav__navitem">
                            <Auth />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <Slide class="mobile-nav" @openMenu="handleOpenMenu" @closeMenu="handleCloseMenu">
            <img class="SearchNav__BrandImage" :src="require('../../assets/images/jhf_logo.svg')" @click="toHome" v-if="this.width < 1001" />

            <ul class="SearchNav__Navigation">
                <li class="SearchNav__navitem">
                    <el-button class="lang-btn" v-if="$store.state.general.language === 'english'" @click.native="language('japanese')">
                        日本語
                    </el-button>
                    <el-button class="lang-btn" v-if="$store.state.general.language === 'japanese'" @click.native="language('english')">
                        English
                    </el-button>
                </li>
                <li class="SearchNav__navitem">
                    <router-link to="/Help" class="">{{'Help' | language}}</router-link>
                </li>
                <li class="SearchNav__navitem">
                    <Auth />
                </li>
            </ul>
        </Slide>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueFormGenerator from 'vue-form-generator';
    import SearchInput from './SearchInput.vue';
    import SearchAdvancedNav from './SearchAdvancedNav';
    import Auth from '../Pages/Auth/Auth';
    import { Slide } from 'vue-burger-menu'

    Vue.use(VueFormGenerator)

    export default {
        components: {
            SearchInput,
            SearchAdvancedNav,
            Auth,
            Slide
        },
        data() {
            return {
                visible2: false,
                visible3: false,
                visible4: false,
                value11: {},
                bedrooms: [1, 5],
                walkdistance: 20,
                budget: [80, 500],
                width: 0,
                marks: {
                    80: '¥80K',
                    100: '¥100K',
                    200: '¥200K',
                    300: '¥300K',
                    400: '¥400K',
                    500: '¥500K+'
                },
                model: {
                    // budget: ['100', '200'],
                    // beds: '1+',
                    // property,
                    // walk,
                    // features
                },
                limitNum: 5,
                searchParams: [],
                selectValue: {},
                options: [{
                    value: 1,
                    label: 1,
                }]
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            toHome() {
                this.$router.push({
                    path: '/',
                    query: {}
                })

            },
            formatTooltip(val) {
                return '¥' + val + 'K';
            },
            distancePopup(val) {
                return 'Less than ' + val + ' mins';
            },
            bedroomPopup(val) {
                return val + ' bedrooms';
            },
            handleOpenMenu() {

            },
            handleCloseMenu() {

            },
            handleResize() {
                this.width = window.innerWidth;
            },
            language(value) {
                this.$store.commit('general/set_language', value);
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
    #app {
        .mobile-nav {
            display: none;
        }

        .bm-menu {
            background-color: $white;
            box-shadow: $box-shadow;
            padding-top: 65px;
            z-index: 10000;

            .el-dropdown {
                display: none;
            }
        }

        .SearchNav__navitem {
            .lang-btn {
                border: none !important;
                color: #3d3d3d !important;
                padding: 0;

                &:hover, &:focus {
                    border: none !important;
                    background: transparent !important;
                    color: $primary-color !important;
                }
            }
        }

        .account-menu-mobile {
            display: none;
            border-top: 1px solid rgba($alternate-color, .2);
            padding: 1rem 0 0 0;

            p {
                margin: 0px 0 0.5rem 0;
                white-space: normal;
                line-height: 1.2em;
                font-size: .75em;
            }

            ul {
                display: block;
                width: 100%;
                padding: 0;

                li {
                    cursor: pointer;
                    font-size: .9em;
                    color: rgba($dark-grey, .75);
                    transition: ease-in-out .2s;

                    .fas {
                        width: 35px;
                    }

                    &:hover {
                        color: $primary-color;
                        text-decoration: underline;
                    }
                }
            }
        }

        .bm-item-list {
            margin: 0 1rem;
            white-space: nowrap;
        }

        .bm-burger-button {
            left: 2rem;
            z-index: 100;
        }

        .cross-style {
            right: 1rem;
            top: 1.45rem;
        }

        .bm-cross-button {
            height: 20px;
            width: 20px;

            .bm-cross {
                height: 20px !important;
                top: 50%;
                left: 50%;

                &:first-child {
                    transform: translate(-50%, -50%) rotate(-45deg) !important;
                }

                &:last-child {
                    transform: translate(-50%, -50%) rotate(45deg)!important;
                }
            }
        }

        .SearchNav {
            position: relative;
            padding: 0rem 2rem;
            box-shadow: $box-shadow;
            z-index: 100;

            &__SubmitContainer {
                margin-top: 0.6rem;
                button {
                    width: auto;
                }
            }
            &__BrandImage {
                cursor: pointer;
                width: 100%;
            }
            &__BrandImageMobile {
                display: none;
            }
            &__Navigation {
                display: inline-block;
                margin: 0;

                li {
                    display: inline-block;
                }
            }
            &__navitem {
                padding-left: 1rem;
                font-weight: bold;

                a {
                    position: relative;
                    color: #424242;
                    text-decoration: none;
                }
            }

            .SearchNav-columns {
                display: table;
                width: 100%;
            }

            .col-logo {
                display: table-cell;
                vertical-align: middle;
                width: 350px;
            }

            .col-search {
                display: table-cell;
                vertical-align: middle;
                padding: 1rem 2rem 0;
                width: 800px;
            }

            .col-nav {
                display: table-cell;
                vertical-align: middle;
                text-align: right;
                white-space: nowrap;
            }
        }

        @media (max-width: 1200px) {
            .bm-burger-button {
                left: 2rem;
                top: 1.65rem;
            }

            .bm-menu {
                .account-menu-mobile {
                    display: block;
                }
            }

            .mobile-nav {
                display: initial;
            }

            .SearchNav {
                .col-logo {
                    width: 250px;
                    vertical-align: top;
                    padding-top: 1.65rem;
                    padding-left: 3em;
                }

                .col-nav {
                    display: none;
                }

                .col-search {
                    padding: 1rem 0 0 4rem;
                    width: 600px;
                }

                &__Navigation {
                    width: 100%;

                    li {
                        display: table;
                        width: 100%;
                        margin: 1rem 0;
                        padding: 0;
                    }
                }
            }
        }

        @media (max-width: 1000px) {
            .SearchNav {
                .col-logo {
                    display: none;
                }

                &__BrandImage {
                    width: 200px;
                    position: absolute;
                    top: 1rem;
                    left: 1rem;
                    padding: 0;
                }
            }
        }

        @media (max-width: 767px) {
            .bm-burger-button {
                left: 1rem;
                top: 1rem;
                width: 30px;
                height: 25px;
            }

            .SearchNav {
                padding: 0 1rem;

                .col-search {
                    padding: .5rem 0 .5rem 2.5rem;
                }
            }
        }
    }
</style>
